export const environment = {
  production: false,
  apiUrl: 'http://localhost:8001/api',
};
